import React from "react"
import PropTypes from "prop-types"

import {
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core"
import ExpandLess from "@material-ui/icons/ExpandLess"
import ExpandMore from "@material-ui/icons/ExpandMore"

import MenuButton from "./MenuButton"


export class CollapsibleItemGroup extends React.Component {
  render() {
    const { props } = this
    let indent = 15

    if (props.icon) {
      indent = 56
    }

    let open = props.activeNavPath.startsWith(props.path)

    return (
      <ListItem>
        <MenuButton className="nav__button" onClick={() => props.onClick(this)}>
          <div className="nav__button-inner">
            {props.icon ? <ListItemIcon>{props.icon}</ListItemIcon> : ""}
            <ListItemText disableTypography primary={props.text}/>
            {open ? <ExpandLess className="nav__action"/> : <ExpandMore className="nav__action"/>}
          </div>
        </MenuButton>
        <Collapse in={open} timeout="auto" unmountOnExit style={{width: "100%"}}>
          <List style={{marginLeft: indent}}>
            {props.children}
          </List>
        </Collapse>
      </ListItem>
    )
  }
}

CollapsibleItemGroup.propTypes = {
  icon: PropTypes.node,
  text: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  path: PropTypes.string,
  activeNavPath: PropTypes.string,
}

CollapsibleItemGroup.defaultProps = {
  onClick: () => {}
}

export default CollapsibleItemGroup
